import { render, staticRenderFns } from "./CaptureModal.vue?vue&type=template&id=4ea22860&"
import script from "./CaptureModal.vue?vue&type=script&lang=js&"
export * from "./CaptureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ea22860')) {
      api.createRecord('4ea22860', component.options)
    } else {
      api.reload('4ea22860', component.options)
    }
    module.hot.accept("./CaptureModal.vue?vue&type=template&id=4ea22860&", function () {
      api.rerender('4ea22860', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Packages/Captures/components/CaptureModal.vue"
export default component.exports